import { render, staticRenderFns } from "./MenuPdv.vue?vue&type=template&id=06dbcc4f&scoped=true"
import script from "./MenuPdv.vue?vue&type=script&lang=js"
export * from "./MenuPdv.vue?vue&type=script&lang=js"
import style0 from "./MenuPdv.vue?vue&type=style&index=0&id=06dbcc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbcc4f",
  null
  
)

export default component.exports